module.exports = __webpack_public_path__ + "static/media/apps-grid.eedfe18c.svg";